export default __webpack_public_path__ + "static/media/subscription-image.979100e6.png";